import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { CommonService } from '../Model/Common/common.service';
import { SessionService } from '../Util/Session/session.service';
import { PostingOrderService } from '../posting-order.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../Model/Combo/combo.service';
import { FormsModule } from '@angular/forms';
import { AllotmentDetailService } from '../allotment-detail.service';

@Component({
  selector: 'app-transfer-order-to-branch-view',
  standalone: true,
  imports: [CommonModule, RouterModule, LoaderComponent, DataTablesModule, NgSelectModule, FormsModule],
  templateUrl: './transfer-order-to-branch-view.component.html',
  styleUrl: './transfer-order-to-branch-view.component.scss'
})
export class TransferOrderToBranchViewComponent {

  isDisabled: boolean = false;
  isSubContractor: boolean = false;
  user: any = {}
  TableData = [] as any;
  Branchs = [] as any;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private download: DownloadSampleService,
    public common: CommonService,
    private session: SessionService,
    private postingService: PostingOrderService,
    private comboload: ComboService,
    private allotmentService: AllotmentDetailService
  ) {
    this.common.getPageRights();
    this.isSubContractor = window.location.pathname.includes('transferordertobranchsub');
    console.log(this.isSubContractor);
    this.user = this.session.GetUserDetails();
    this.Filter.LoginUserID = this.user.UserId
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Filter = {
    SelectType: 'Transfer Order To Other Branch',
    EmpMasterID: '0',
    LoginUserID: '0',
    DesignationID: '',
    GroupID: '',
    DutyID: '',
    BankAccountNo: '',
    FinancialYear: '',
    BranchId: null as any,
    ClientId: null as any
  }

  SubContractData() {
    this.isDisabled = true
    this.postingService.SubContractorDocument(this.Filter).subscribe({
      next: (response) => {
        this.TableData = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetData() {
    this.isDisabled = true
    this.allotmentService.AllotmentView({
      SelectType: 'Transfer Order To Other Branch',
      LoginUserID: Number(this.user.UserId),
      BranchId: this.Filter.BranchId == null ? 0 : this.Filter.BranchId,
      ClientId: 0,
      SiteId: 0,
    }).subscribe({
      next: (response) => {
        this.TableData = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    if (this.TableData.length > 0) {
      this.download.exportToExcel(this.TableData, "Transfer Order To Other Branch");
      this.isDisabled = false
    }
    else {
      alert('No Data Found');
      this.isDisabled = false
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;

    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': this.Filter.BranchId,
      'ClientId': this.Filter.ClientId,
      'SiteId': 0,
      'EmpType': 'front',
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}